import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, Observable, Subject, withLatestFrom } from 'rxjs';

import { SharedAuthFacade } from '@lockton-apps/shared/data-access/auth';
import { CoreFacade } from '@lockton-apps/shared/data-access/core';
import {
  FeedbackService,
  RlaGuards,
  UiModule,
} from '@lockton-apps/shared/ui/lui';
import {
  bottomBar,
  BottomBarService,
} from '@lockton-apps/shared/util/bottom-bar';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { LetDirective } from '@ngrx/component';
import { MaterialModule } from '@lockton-apps/material';

@Component({
    selector: 'latam-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        UiModule,
        MaterialModule,
        LetDirective,
        PortalModule,
    ],
    animations: [bottomBar],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements OnDestroy {
  @Output() logout = new EventEmitter();
  @Output() switchUser = new EventEmitter();

  isAuthenticated$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    withLatestFrom(this.authFacade.isAuthenticated$),
    map(([, isAuthenticated]) => isAuthenticated)
  );

  menuLinks$ = this.coreFacade.primaryNav$;

  userMenu$ = this.coreFacade.userMenu$;

  footerLinks$ = this.coreFacade.footerNav$;

  destroy$ = new Subject();

  loading$ = this.feedbackService.loadingOverlay$;

  rlaGuards = RlaGuards;

  offices = [
    {
      country: 'Argentina',
      location:
        'Lockton Sociedad de Productores Asesores de Seguros S.A., con domicilio en Arribeños, 1408 – Buenos Aires y registrado en SSN con el número 879.',
    },
    {
      country: 'Brasil',
      location:
        'Lockton Brasil Consultoria e Corretora de Seguros Ltda, com domicílio comercial na Av. das Nações Unidas, 14.171 – 14º e 16º andares, Vila Gertrudes - São Paulo - SP - cep: 04794-000, registrada na Susep sob o nº 202020084.',
    },
    {
      country: 'Chile',
      location:
        'Lockton Chile Corredores de Seguros SPA, con domicilio en Orinoco 90, piso 20, Las Condes, Santiago, y registrado en CFM con el número 8.861.',
    },
    {
      country: 'Colombia',
      location:
        'Lockton Sekuritas S.A. Corredores de Seguros, con domicilio principal en Cra. 11 No. 86 – 60, oficina 404, Bogotá D.C.y registrado en la SFC con el número de Certificado S.B. 128 del 18 de noviembre de 1994.',
    },
    {
      country: 'México',
      location:
        'Lockton México Agente de Seguros y de Fianzas, S.A. de C.V., con domicilio principal en Av. Santa Fe 481 piso 20, Colonia Cruz Manca, Alcaldía Cuajimalpa de Morelos, C.P. 05349, Ciudad de México, y registrado en la CNSF con el número de expediente 731.1(05)/481',
    },
    {
      country: 'Perú',
      location:
        'Lockton Peru Corredores de Seguros S.A.C., con domicilio en Av. Victor Andres Belaunde Nro 147 Int. 1101 (Edificio Real ocho), San Isidro, Lima, y registrado en la SBS con el número J0906.',
    },
    {
      country: 'Uruguay',
      location:
        'Lockton Corredores de Seguros S.A, sociedad de responsabilidad limitada, con domicilio en Luis A. Herrera 1248 /WTC Torre 3 of.1076.',
    },
  ];

  constructor(
    public bottomBarService: BottomBarService,
    private authFacade: SharedAuthFacade,
    private router: Router,
    private feedbackService: FeedbackService,
    private coreFacade: CoreFacade
  ) {}

  ngOnDestroy(): void {
    this.destroy$.complete();
  }
}
